// extracted by mini-css-extract-plugin
export default {"icon":"Settings_icon__RtYs8","wrapper":"Settings_wrapper__4QthU","content":"Settings_content__WO24B","title":"Settings_title__gveO6","item":"Settings_item__GbpVC"};